'use client';

import { type ReactNode, createContext, useRef, type JSX } from 'react';

import type { SystemEnumsState } from '../stores/systemEnumsStore';
import { createSystemEnumsStore } from '../stores/systemEnumsStore';

export type SystemEnumsStoreApi = ReturnType<typeof createSystemEnumsStore>;

export type SystemEnumsStoreProviderProps = {
    children: ReactNode;
    systemEnumsState?: SystemEnumsState;
};

// TODO: Refactor this later to use the correct naming convention
// eslint-disable-next-line @typescript-eslint/naming-convention
export const SystemEnumsStoreContext = createContext<SystemEnumsStoreApi | undefined>(undefined);

export function SystemEnumsStoreProvider({ children, systemEnumsState }: SystemEnumsStoreProviderProps): JSX.Element {
    const storeRef = useRef<SystemEnumsStoreApi>(undefined);

    if (!storeRef.current) {
        storeRef.current = createSystemEnumsStore(systemEnumsState);
    }

    return <SystemEnumsStoreContext.Provider value={storeRef.current}>{children}</SystemEnumsStoreContext.Provider>;
}
